"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreementTermToJSON = exports.AgreementTermFromJSONTyped = exports.AgreementTermFromJSON = void 0;
var _1 = require("./");
function AgreementTermFromJSON(json) {
    return AgreementTermFromJSONTyped(json, false);
}
exports.AgreementTermFromJSON = AgreementTermFromJSON;
function AgreementTermFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'type': (0, _1.AgreementTermTypeFromJSON)(json['type']),
        'file': (0, _1.DocumentFromJSON)(json['file']),
    };
}
exports.AgreementTermFromJSONTyped = AgreementTermFromJSONTyped;
function AgreementTermToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'type': (0, _1.AgreementTermTypeToJSON)(value.type),
        'file': (0, _1.DocumentToJSON)(value.file),
    };
}
exports.AgreementTermToJSON = AgreementTermToJSON;
